import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExpandMore } from '@material-ui/icons';
import { Button, CircularProgress } from '@material-ui/core';

import { hooks } from './hooks';
import { StoreStatusCard } from '../../store-status-card';
import { MultiStoreNotification } from '../../multi-store-notification';

import EventActions from '../../../../redux/actions/event-actions/event.actions';

import useCStyles from './ContentDropdown.styles';
import Paths from '../../../../constants/Paths';
import { amplitudPartnerType as amplitudPT, CtaUiModes } from '../../constants';

import type { ContentDropdownProps } from './ContentDropdown.types';

// +++++ ContentDropdown
export function ContentDropdown(props: ContentDropdownProps): JSX.Element {
  const {
    partnerId,
    list = [],
    isLarge = false,
    singleStore = null,
    isSingleStore = true,
    isStoreStatusDetailLoading = false,
  } = props;

  const classes = useCStyles();
  const navigate = useNavigate();

  const textIds = hooks.useTexts();

  const handleGoToManageStores = () => {
    EventActions.onClickStoreStatusDropGoToStoreAdminPage({
      partnerId,
      typePartner: isSingleStore ? amplitudPT.single : amplitudPT.many,
    });
    navigate(Paths.STORE_MANAGEMENT);
  };

  return (
    <section className={classes.container}>
      {!isSingleStore && <MultiStoreNotification stores={list} />}
      {!isSingleStore && (
        <div className={classes.wrapperManageStoreBtn}>
          <Button
            size='large'
            color='primary'
            onClick={handleGoToManageStores}
            variant={isLarge ? 'text' : 'outlined'}
            endIcon={isLarge ? <ExpandMore /> : null}
            classes={{
              root: classes.manageStoresBtn,
              endIcon: classes.manageStoresBtnEndIcon,
            }}
          >
            {textIds.manageStoresBtn}
          </Button>
        </div>
      )}
      {isSingleStore && isStoreStatusDetailLoading && (
        <CircularProgress
          color='inherit'
          classes={{ root: classes.loadingSingleStore }}
        />
      )}
      {isSingleStore && !!singleStore && !isStoreStatusDetailLoading && (
        <StoreStatusCard
          partnerId={partnerId}
          cta={singleStore.cta_type}
          status={singleStore.status}
          storeId={singleStore.store_id}
          msg1={singleStore.first_message}
          msg2={singleStore.second_message}
          storeName={singleStore.store_name}
          ctaUiMode={!isLarge ? CtaUiModes.CenterPlus : CtaUiModes.Right}
          growUp={!isLarge}
          isSingleStore={isSingleStore}
        />
      )}
    </section>
  );
}
// ----- ContentDropdown
